/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Algorithm_Sha256_HintInputs */



/**
* | output |
* | --- |
* | "More secure. Works with Google Authenticator (v6+), 1Password, Authy and Bitwarden." |
*
* @param {Profile_Security_Totp_Algorithm_Sha256_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_algorithm_sha256_hint = /** @type {((inputs?: Profile_Security_Totp_Algorithm_Sha256_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Algorithm_Sha256_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sicherer. Funktioniert mit Google Authenticator (v6+), 1Password, Authy und Bitwarden.")
	return /** @type {LocalizedString} */ ("More secure. Works with Google Authenticator (v6+), 1Password, Authy and Bitwarden.")
});